import { render } from "./ChannelItems.vue?vue&type=template&id=72744298&scoped=true"
import script from "./ChannelItems.vue?vue&type=script&lang=js"
export * from "./ChannelItems.vue?vue&type=script&lang=js"

import "./ChannelItems.vue?vue&type=style&index=0&id=72744298&lang=scss&scoped=true"

import exportComponent from "C:\\Workspaces\\livetv\\vuefront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72744298"]])

export default __exports__